class AnnouncementBarSlider extends HTMLElement {
	constructor() {
		super();
		this.embla = null;
		this.autoplay = null;
	}

	connectedCallback() {
		this.initSlider();
	}

	initSlider() {
		if (typeof EmblaCarousel === 'undefined') {
			setTimeout(() => this.initSlider(), 100);
			return;
		}

		const viewport = this.querySelector('.embla__viewport');
		if (!viewport) return;

		const options = {
			loop: true,
			duration: 25,
			align: 'center',
			slidesToScroll: 1
		};

		this.embla = EmblaCarousel(viewport, options);

		// Initialize arrow buttons
		this.initArrows();

		if (this.hasAttribute('data-embla-auto')) {
			const speedSeconds = parseInt(this.getAttribute('data-speed-seconds')) || 3;
			this.initAutoplay(speedSeconds);
		}
	}

	initArrows() {
		if (!this.embla) return;

		const prevButton = this.querySelector('[data-announcement-arrow="prev"]');
		const nextButton = this.querySelector('[data-announcement-arrow="next"]');

		if (prevButton) {
			prevButton.addEventListener('click', () => {
				if (this.embla.canScrollPrev()) {
					this.embla.scrollPrev();
				} else {
					this.embla.scrollTo(this.embla.slideNodes().length - 1);
				}
			});
		}

		if (nextButton) {
			nextButton.addEventListener('click', () => {
				if (this.embla.canScrollNext()) {
					this.embla.scrollNext();
				} else {
					this.embla.scrollTo(0);
				}
			});
		}

		// Update button states on scroll (for loop carousel, buttons are always enabled)
		const updateButtons = () => {
			// Since loop is enabled, buttons are always functional
			// But we can still update visual states if needed
			if (prevButton) {
				prevButton.disabled = false;
			}
			if (nextButton) {
				nextButton.disabled = false;
			}
		};

		this.embla.on('select', updateButtons);
		updateButtons();
	}

	initAutoplay(speedSeconds) {
		if (!this.embla) return;

		const autoplay = () => {
			if (document.querySelector('.announcement-bar__bfcm-tooltip-content.active')) {
				return;
			}
			if (this.embla.canScrollNext()) {
				this.embla.scrollNext();
			} else {
				this.embla.scrollTo(0);
			}
		};

		this.autoplay = setInterval(autoplay, speedSeconds * 1000);

		this.addEventListener('mouseenter', () => {
			if (this.autoplay) {
				clearInterval(this.autoplay);
				this.autoplay = null;
			}
		});

		this.addEventListener('mouseleave', () => {
			if (this.hasAttribute('data-embla-auto') && !this.autoplay) {
				const speedSeconds = parseInt(this.getAttribute('data-speed-seconds')) || 3;
				this.autoplay = setInterval(autoplay, speedSeconds * 1000);
			}
		});
	}

	disconnectedCallback() {
		if (this.autoplay) {
			clearInterval(this.autoplay);
			this.autoplay = null;
		}
		if (this.embla) {
			this.embla.destroy();
			this.embla = null;
		}
	}
}

if (!customElements.get('announcement-bar-slider')) {
	customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}

(function() {
	function initTooltips() {
		document.querySelectorAll('.announcement-bar__bfcm-tooltip-button').forEach(function(button) {
			if (button.dataset.tooltipInitialized) return;
			button.dataset.tooltipInitialized = 'true';

			button.addEventListener('click', function(e) {
				e.stopPropagation();
				e.preventDefault();
				var tooltip = this.nextElementSibling;
				var isActive = this.classList.contains('active');
				document.querySelectorAll('.announcement-bar__bfcm-tooltip-button').forEach(function(otherButton) {
					if (otherButton !== this) {
						otherButton.classList.remove('active');
						var otherTooltip = otherButton.nextElementSibling;
						if (otherTooltip) {
							otherTooltip.classList.remove('active');
						}
					}
				}.bind(this));
				if (isActive) {
					this.classList.remove('active');
					if (tooltip) {
						tooltip.classList.remove('active');
					}
				} else {
					this.classList.add('active');
					if (tooltip) {
						tooltip.classList.add('active');
					}
				}
			});

			button.addEventListener('touchend', function(e) {
				e.stopPropagation();
				e.preventDefault();
				var tooltip = this.nextElementSibling;
				var isActive = this.classList.contains('active');
				document.querySelectorAll('.announcement-bar__bfcm-tooltip-button').forEach(function(otherButton) {
					if (otherButton !== this) {
						otherButton.classList.remove('active');
						var otherTooltip = otherButton.nextElementSibling;
						if (otherTooltip) {
							otherTooltip.classList.remove('active');
						}
					}
				}.bind(this));
				if (isActive) {
					this.classList.remove('active');
					if (tooltip) {
						tooltip.classList.remove('active');
					}
				} else {
					this.classList.add('active');
					if (tooltip) {
						tooltip.classList.add('active');
					}
				}
			});
		});

		document.querySelectorAll('.announcement-bar__bfcm-tooltip-close').forEach(function(closeButton) {
			if (closeButton.dataset.closeInitialized) return;
			closeButton.dataset.closeInitialized = 'true';

			closeButton.addEventListener('click', function(e) {
				e.stopPropagation();
				e.preventDefault();
				var tooltip = this.closest('.announcement-bar__bfcm-tooltip-content');
				var button = tooltip ? tooltip.previousElementSibling : null;
				if (tooltip) {
					tooltip.classList.remove('active');
				}
				if (button && button.classList.contains('announcement-bar__bfcm-tooltip-button')) {
					button.classList.remove('active');
				}
			});

			closeButton.addEventListener('touchend', function(e) {
				e.stopPropagation();
				e.preventDefault();
				var tooltip = this.closest('.announcement-bar__bfcm-tooltip-content');
				var button = tooltip ? tooltip.previousElementSibling : null;
				if (tooltip) {
					tooltip.classList.remove('active');
				}
				if (button && button.classList.contains('announcement-bar__bfcm-tooltip-button')) {
					button.classList.remove('active');
				}
			});
		});

		document.addEventListener('click', function(e) {
			if (!e.target.closest('.announcement-bar__bfcm-tooltip')) {
				document.querySelectorAll('.announcement-bar__bfcm-tooltip-button').forEach(function(button) {
					button.classList.remove('active');
				});
				document.querySelectorAll('.announcement-bar__bfcm-tooltip-content').forEach(function(tooltip) {
					tooltip.classList.remove('active');
				});
			}
		});

		document.addEventListener('touchend', function(e) {
			if (!e.target.closest('.announcement-bar__bfcm-tooltip')) {
				document.querySelectorAll('.announcement-bar__bfcm-tooltip-button').forEach(function(button) {
					button.classList.remove('active');
				});
				document.querySelectorAll('.announcement-bar__bfcm-tooltip-content').forEach(function(tooltip) {
					tooltip.classList.remove('active');
				});
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTooltips);
	} else {
		initTooltips();
	}

	if (typeof Shopify !== 'undefined' && Shopify.designMode) {
		document.addEventListener('shopify:section:load', initTooltips);
	}
})();

